import axios from "axios";

//Seviye Listesi
export function getLevelList() {
  return axios.get(process.env.VUE_APP_API_URL + "Class/level");
}

//Öğrenim Türü Listesi
export function getEducationTypeList() {
  return axios.get(process.env.VUE_APP_API_URL + "Class/educationtype");
}

//Ücret Türü Listesi
export function getPaidList() {
  return axios.get(process.env.VUE_APP_API_URL + "Class/paid");
}

//Ülke Listesi
export function getCountries() {
  return axios.get(process.env.VUE_APP_API_URL + "Form/getallcountry");
}

//Eyalet Listesi
export function getStates(countryId) {
  const config = {
    params: {
      countryId: countryId,
    },
  };
  return axios.get(process.env.VUE_APP_API_URL + "Form/getallstate", config);
}

//Şehir Listesi
export function getCities(statesId) {
  const config = {
    params: {
      statesId: statesId,
    },
  };
  return axios.get(process.env.VUE_APP_API_URL + "Form/getallcity", config);
}

//Gün Listesi
export function getDayList() {
  return axios.get(process.env.VUE_APP_API_URL + "Class/day");
}

//Merkez Listesi
export function getCenterList() {
  return axios.get(process.env.VUE_APP_API_URL + "Class/centerList");
}

//MerkezId ile Dönem Listesi
export function getPeriodListByCenterId(centerId) {
  return axios.get(process.env.VUE_APP_API_URL + "Class/period?centerId=" + centerId);
}

//Merkez Listesi
export function getUserCenterList() {
  return axios.get(process.env.VUE_APP_API_URL + "Center/center");
}

//MerkezId ile Dönem Listesi
export function getUserPeriodListByCenterId(centerId) {
  const config = {
    params: {
      centerId: centerId,
    },
  };
  return axios.get(process.env.VUE_APP_API_URL + "Center/centerperiod", config);
}

//Dönem Crud İşlemleri
export function addPeriod(periodModel) {
  return axios.post(process.env.VUE_APP_API_URL + "Center/addperiod", periodModel);
}

export function updatePeriod(periodModel) {
  return axios.put(process.env.VUE_APP_API_URL + "Center/updateperiod", periodModel);
}

export function deletePeriod(periodId) {
  const config = {
    params: {
      periodId: periodId,
    },
  };
  return axios.delete(process.env.VUE_APP_API_URL + "Center/deleteperiod", config);
}

//Öğrenci Seçimi Listesi /** Havuz veya Sınıfa atanmış */
export function getStudentSelectionList() {
  return axios.get(process.env.VUE_APP_API_URL + "Class/studentselection");
}
